/* SMUKIEZ home: bouncing OPEN, typed wordmark, live clock, random link. */
(() => {
  const root = document.querySelector("[data-smk-home]");
  if (!root) return;
  const SMK = window.SMK || {};
  const Sound = SMK.Sound || { play() {}, unlock() {} };
  const KEY = "smukiez_audio_unlocked";
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const title = root.dataset.title || "SMUKIEZ";
  const typeMs = parseInt(root.dataset.typeMs, 10) || 170;
  const overlay = root.querySelector("[data-open]");
  const typed = root.querySelector("[data-typed]");
  const clockOut = root.querySelector("[data-clock-out]");
  const clockText = root.querySelector("[data-clock-text]");
  let opened = false;

  root.querySelectorAll("[data-smk-stagger]").forEach((el, i) => el.style.setProperty("--i", i));

  function typeTitle() {
    if (!typed) return;
    let i = 0;
    typed.textContent = "";
    const step = () => {
      if (i >= title.length) { root.classList.add("is-typed"); return; }
      typed.textContent += title.charAt(i++);
      Sound.play("type", { rate: 0.92 + Math.random() * 0.16 });
      setTimeout(step, reduced ? 0 : typeMs * (0.7 + Math.random() * 0.6));
    };
    setTimeout(step, 320);
  }

  function startClock() {
    if (!clockText) return;
    const opts = { weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" };
    const tick = () => {
      clockText.textContent = new Date().toLocaleString([], opts).toUpperCase();
      if (clockOut) { clockOut.classList.remove("is-tick"); void clockOut.offsetWidth; clockOut.classList.add("is-tick"); }
      if (root.dataset.tick === "true" && document.visibilityState === "visible") Sound.play("tick");
    };
    tick();
    setInterval(tick, 1000);
  }

  function open() {
    if (opened) return;
    opened = true;
    Sound.unlock();
    if (root.dataset.remember === "true") { try { localStorage.setItem(KEY, "true"); } catch (e) { /* ignore */ } }
    if (overlay) {
      overlay.classList.add("is-closing");
      overlay.setAttribute("aria-hidden", "true");
      setTimeout(() => overlay.remove(), 700);
    }
    root.classList.add("is-open");
    typeTitle();
    startClock();
  }

  if (overlay) {
    const btn = overlay.querySelector("[data-open-btn]");
    const oc = overlay.querySelector("[data-open-clock]");
    let x = 60, y = 60, vx = 2.4, vy = 2.0, raf = 0;
    const move = () => {
      const w = overlay.clientWidth, h = overlay.clientHeight, bw = btn.offsetWidth, bh = btn.offsetHeight;
      x += vx; y += vy;
      let hit = false;
      if (x <= 0) { x = 0; vx = Math.abs(vx); hit = true; } else if (x >= w - bw) { x = w - bw; vx = -Math.abs(vx); hit = true; }
      if (y <= 0) { y = 0; vy = Math.abs(vy); hit = true; } else if (y >= h - bh) { y = h - bh; vy = -Math.abs(vy); hit = true; }
      if (hit) { btn.classList.remove("is-hit"); void btn.offsetWidth; btn.classList.add("is-hit"); }
      btn.style.transform = `translate(${x}px, ${y}px)`;
      raf = requestAnimationFrame(move);
    };
    const oClock = () => { if (oc) oc.textContent = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" }).toUpperCase(); };
    oClock();
    const ot = setInterval(oClock, 1000);

    let remembered = false;
    try { remembered = localStorage.getItem(KEY) === "true"; } catch (e) { /* ignore */ }
    if (remembered && root.dataset.remember === "true") {
      clearInterval(ot);
      overlay.remove();
      open();
    } else {
      if (reduced) { x = Math.max(0, overlay.clientWidth / 2 - 90); y = Math.max(0, overlay.clientHeight / 2 - 40); btn.style.transform = `translate(${x}px, ${y}px)`; }
      else raf = requestAnimationFrame(move);
      const go = e => {
        e.preventDefault();
        Sound.unlock();
        Sound.play("click");
        cancelAnimationFrame(raf);
        clearInterval(ot);
        open();
      };
      btn.addEventListener("click", go);
      overlay.addEventListener("click", e => { if (!e.target.closest("[data-open-btn]")) go(e); });
    }
  } else {
    open();
  }

  // Random: one of the listed links, through the same click-and-wait as every other link.
  root.querySelectorAll("[data-random]").forEach(a => {
    a.addEventListener("click", e => {
      e.preventDefault();
      const list = (a.dataset.random || "").split(/\s+/).filter(Boolean);
      if (!list.length) return;
      a.classList.add("is-pressed");
      const url = list[Math.floor(Math.random() * list.length)];
      if (SMK.leave) SMK.leave(url); else window.location.href = url;
    });
  });
})();
